module.exports = __webpack_public_path__ + "static/media/tour-3.5c797833.png";